import { useEffect } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { useIntegrations, useUserRole } from '../../../../api/query';
import { DashboardView } from '../../../../pages';
import { useIntegrationsDashboardShallowStore } from '../../../../store';

const DEFAULT_INTEGRATIONS_DATA = { integrations: [], integrationsMetadata: undefined };

const Dashboard = () => {
  const { authenticatedUser } = Route.useLoaderData();
  const {
    data,
    isLoading: isIntegrationsLoading,
    isFetching: isIntegrationsFetching,
    isError: isIntegrationsError,
    isLoadingError: isIntegrationsLoadingError,
  } = useIntegrations();
  const {
    data: userData,
    isLoading: isUserLoading,
    isFetching: isUserFetching,
    isError: isUserError,
    isLoadingError: isUserLoadingError,
  } = useUserRole(authenticatedUser?.username);
  const { setIsUserLoggingIn } = useIntegrationsDashboardShallowStore('setIsUserLoggingIn');

  useEffect(() => {
    setIsUserLoggingIn(false);
  }, []);

  const { integrations, integrationsMetadata } = data?.data ?? DEFAULT_INTEGRATIONS_DATA;
  const userRole = userData?.data?.role;

  return (
    <DashboardView
      authenticatedUser={authenticatedUser}
      integrations={integrations}
      integrationsMetadata={integrationsMetadata}
      userRole={userRole}
      isLoading={isIntegrationsLoading || isIntegrationsFetching || isUserLoading || isUserFetching}
      isError={isIntegrationsError || isIntegrationsLoadingError || isUserError || isUserLoadingError}
    />
  );
};

export const Route = createFileRoute('/_auth/dashboard/')({
  component: Dashboard,
  loader: ({ context }) => {
    return { authenticatedUser: context.user };
  },
});
